import { LoanActionType, LoanType, RepaymentLevelType } from '../LoanConstants';
import { loanActions } from '@apply/adminStore';
import { getDrawBudgetURL } from '../LoanFunctions';
import { Location } from 'react-router-dom';

export const executeLoanAction = (itemData, dispatch, location: Location, showInsurance = false) => {
    const onModify = (loanId: number, loanTypeId: LoanType) => {
        switch (loanTypeId) {
            case LoanType.MasterNote:
                dispatch(
                    loanActions.setEditMasterNoteModal({
                        editMasterNoteModal: {
                            isOpen: true,
                            loanId,
                            showInsurance: !!showInsurance,
                        },
                    })
                );
                break;
            default:
                dispatch(
                    loanActions.setEditStdLoanModal({
                        editStdLoanModal: {
                            isOpen: true,
                            loanId,
                            showInsurance: !!showInsurance,
                        },
                    })
                );
        }
    };

    const onAddSubNote = (loanId: number) => {
        dispatch(
            loanActions.setEditStdLoanModal({
                editStdLoanModal: {
                    isOpen: true,
                    masterNoteId: loanId,
                    showInsurance: !!showInsurance,
                },
            })
        );
    };

    const onDelete = (loanId: number) => {
        dispatch(
            loanActions.setDeleteLoanModal({
                deleteLoanModal: { isOpen: true, loanId },
            })
        );
    };

    const onLost = (loanId: number) => {
        dispatch(
            loanActions.setLoseLoanModal({
                loseLoanModal: { isOpen: true, loanId },
            })
        );
    };

    const onExtend = (loanId: number) => {
        dispatch(
            loanActions.setExtensionModal({
                extensionModal: { isOpen: true, loanId },
            })
        );
    };

    const onPropertyRepay = (propertyId: number) => {
        dispatch(
            loanActions.setRepaymentModal({
                repaymentModal: {
                    isOpen: true,
                    entityLevel: RepaymentLevelType.Property,
                    entityId: propertyId,
                },
            })
        );
    };

    const onLoanRepay = (loanId: number) => {
        dispatch(
            loanActions.setRepaymentModal({
                repaymentModal: {
                    isOpen: true,
                    entityLevel: RepaymentLevelType.Loan,
                    entityId: loanId,
                },
            })
        );
    };

    const onReleaseHoldback = (propertyId: number) => {
        dispatch(
            loanActions.setReleaseHoldbackModal({
                holdbackReleaseModal: { isOpen: true, propertyId },
            })
        );
    };

    const onRentalDscr = (propertyId: number) => {
        dispatch(
            loanActions.setRentalDscrModal({
                rentalDscrModal: { isOpen: true, propertyId },
            })
        );
    };

    const OnBuildRentConvert = (loanId: number) => {
        dispatch(
            loanActions.setBuildRentConversionModal({
                buildRentConversionModal: { isOpen: true, loanId },
            })
        );
    };

    const onRevertToApproved = (loanId: number) => {
        dispatch(
            loanActions.setRevertToApprovedModal({
                revertToApprovedModal: { isOpen: true, loanId },
            })
        );
    };

    const onRestore = (loanId: number) => {
        dispatch(
            loanActions.setRestoreLoanModal({
                restoreLoanModal: { isOpen: true, loanId },
            })
        );
    };

    const onInsurance = (loanId: number, propertyId: number) => {
        dispatch(
            loanActions.setPropertyInsuranceModal({
                propertyInsuranceModal: { isOpen: true, loanId, propertyId },
            })
        );
    };

    const onChangeLoanType = (loanId: number) => {
        dispatch(
            loanActions.setChangeLoanTypeModal({
                changeLoanTypeModal: { isOpen: true, loanId },
            })
        );
    };

    const onOpenDrawBudget = (drawBudgetId: number, location: Location) => {
        window.location.href = getDrawBudgetURL(drawBudgetId, location);
    };

    const onOpenLoanSummary = (loanId: number) => {
        dispatch(
            loanActions.setLoanSummaryModal({
                loanSummaryModal: { isOpen: true, loanId },
            })
        );
    };

    const onOpenTerminateMasterNote = (loanId: number) => {
        dispatch(
            loanActions.setTerminateMasterNoteModal({
                terminateMasterNoteModal: { isOpen: true, loanId },
            })
        );
    };

    const onAuditHistory = (loanId: number) => {
        dispatch(
            loanActions.setAuditHistoryModal({
                auditHistoryModal: { isOpen: true, loanId },
            })
        );
    };

    const onLoanSetupSheetGenerate = (loanId: number, bfiNumber: string, loanTypeId: number) => {
        dispatch(
            loanActions.setLoanSetupSheetModal({
                loanSetupSheetModal: { isOpen: true, loanId, bfiNumber, loanTypeId },
            })
        );
    };

    const onNotImplemented = () => {
        alert('Not Implemented yet!');
    };

    switch (itemData.id) {
        case LoanActionType.Modify:
            onModify(itemData.loanId, itemData.loanTypeId);
            break;
        case LoanActionType.Lost:
            onLost(itemData.loanId);
            break;
        case LoanActionType.Extend:
            onExtend(itemData.loanId);
            break;
        case LoanActionType.Delete:
            onDelete(itemData.loanId);
            break;
        case LoanActionType.Restore:
            onRestore(itemData.loanId);
            break;
        case LoanActionType.PropertyRepayment:
            onPropertyRepay(itemData.propertyId);
            break;
        case LoanActionType.LoanRepayment:
            onLoanRepay(itemData.loanId);
            break;
        case LoanActionType.ReleaseHoldback:
            onReleaseHoldback(itemData.propertyId);
            break;
        case LoanActionType.RentalDscr:
            onRentalDscr(itemData.propertyId);
            break;
        case LoanActionType.Convert:
            OnBuildRentConvert(itemData.loanId);
            break;
        case LoanActionType.RevertToApproved:
            onRevertToApproved(itemData.loanId);
            break;
        case LoanActionType.AddSubNote:
            onAddSubNote(itemData.loanId);
            break;
        case LoanActionType.Insurance:
            onInsurance(itemData.loanId, itemData.propertyId);
            break;
        case LoanActionType.ChangeLoanType:
            onChangeLoanType(itemData.loanId);
            break;
        case LoanActionType.OpenDrawBudget:
            onOpenDrawBudget(itemData.drawBudgetId, location);
            break;
        case LoanActionType.Summary:
            onOpenLoanSummary(itemData.loanId);
            break;
        case LoanActionType.TerminateMasterNote:
            onOpenTerminateMasterNote(itemData.loanId);
            break;
        case LoanActionType.AuditHistory:
            onAuditHistory(itemData.loanId);
            break;
        case LoanActionType.LoanSetupSheet:
            onLoanSetupSheetGenerate(itemData.loanId, itemData.bfiNumber, itemData.loanTypeId);
            break;
        default:
            onNotImplemented();
            break;
    }
};
